export const GET_UNPAIDRESERVATIONS_START = 'GET_UNPAIDRESERVATIONS_START';
export const GET_UNPAIDRESERVATIONS_SUCCESS = 'GET_UNPAIDRESERVATIONS_SUCCESS';
export const GET_UNPAIDRESERVATIONS_FAILED = 'GET_UNPAIDRESERVATIONS_FAILED';

export const RESET_UNPAIDRESERVATIONS = 'RESET_UNPAIDRESERVATIONS';
